import { JoinLiveGameSheet } from '@/components/JoinLiveGameSheet/JoinLiveGameSheet'

export default function () {
  return <JoinLiveGameSheet />
}
